export default __webpack_public_path__ + "static/media/spark_30.5414b381.png";